import { Routes } from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { CommitmentComponent } from '../coaching-commitment/commitment/commitment.component';
import { ObservationComponent } from '../coaching-observation/observation/observation.component';
import { CanDeactivateService } from '../common/common.service';

import { CoachingDetailComponent } from './coaching-detail.component';
import { CoachingDetailPillarThreeComponent } from './pillar-three/pillar-three.component';

export const CoachingDetailRoutes: Routes = [
    {
        path: 'coaching-detail',
        canActivate: [AuthService],
        children: [
            {
                path: ':userId',
                component: CoachingDetailComponent,
                canDeactivate: [CanDeactivateService],
                children: [
                    {
                        path: '',
                        component: CoachingDetailPillarThreeComponent,
                    },
                    {
                        path: 'commitment',
                        redirectTo: 'commitments',
                    },
                    {
                        path: 'commitments',
                        children: [
                            {
                                path: ':commitmentId',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                            {
                                path: ':commitmentId/drafts/:draftId',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                            {
                                path: ':commitmentId/drafts/:draftId/approvals/:approvalId',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                        ],
                    },
                    {
                        path: 'draftcommitments',
                        children: [
                            {
                                path: '',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                            {
                                path: ':draftId',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                            {
                                path: ':draftId/approvals/:approvalId',
                                component: CommitmentComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                        ],
                    },
                    {
                        path: 'observation',
                        children: [
                            {
                                path: '',
                                component: ObservationComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                            {
                                path: ':observationId',
                                component: ObservationComponent,
                                canDeactivate: [CanDeactivateService],
                                runGuardsAndResolvers: 'always',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
